<template>
    <div class="pageHeader">
        <el-page-header @back="backPage">
            <template #content>
                <el-breadcrumb :separator-icon="ArrowRight">
                    <template v-for="(route, index) in history" :key="index">
                        <el-breadcrumb-item>
                            <span>{{ route.meta?.title }}</span>
                        </el-breadcrumb-item>
                    </template>

                </el-breadcrumb>
            </template>
            <template #extra>
                <div class="user">
                    <el-avatar shape="square" :size="40" :src="userInfo.avatar" icon="UserFilled" />
                    <div class="info col">
                        <div class="days">{{ userInfo.companyName }}</div>
                        <div class="name">{{ userInfo.nickname }}</div>

                    </div>
                    <el-icon>
                        <arrow-down />
                    </el-icon>
                    <div class="extraBox">
                        <div class="card">
                            <div class="title">
                                <span>{{ userInfo.companyName }}</span>

                            </div>
                            <div class="content">
                                <div class="uinfo">
                                    <el-avatar shape="square" :size="50" :src="userInfo.avatar" icon="UserFilled" />
                                    <div class="info">
                                        <div class="name row">{{ userInfo.nickname }}</div>
                                        <div class="row" v-if="userInfo.wx_bind_time">
                                            <span class="nickname">绑定微信：{{ userInfo.wx_nickname }}</span>
                                            <el-button type="primary" size="small" @click="showDialog('2')" link>查看详情</el-button>
                                        </div>
                                        <div class="row" v-else>
                                            <span class="nickname">绑定微信：未绑定</span>
                                            <el-button type="success" size="small" @click="showDialog('2')" link>立即绑定</el-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="rows">
                                    <div class="row">
                                        <span>API点数：{{ userInfo.points || 0 }}</span>
                                        <el-button type="success" size="small" link @click="toVersion">前往充值</el-button>
                                    </div>
                                    <div>剩余天数：{{ userInfo.days }}天</div>
                                    <div class="row">手机号码：{{ userInfo.phone || '-' }}</div>
                                    <div class="row">电子邮箱：{{ userInfo.email || '-' }}</div>

                                </div>
                            </div>
                        </div>
                        <div class="footer">

                            <el-button type="primary" link icon="Key" @click="showDialog('1')">修改密码</el-button>
                            <!-- <el-button type="success" link icon="Link" @click="showDialog('2')">绑定微信</el-button> -->
                            <el-button type="danger" link icon="User" @click="logOut">退出登录</el-button>

                        </div>
                    </div>
                </div>
                <!-- <el-dropdown>

                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item icon="Key" @click="showDialog('1')">修改密码</el-dropdown-item>
                            <el-dropdown-item icon="Link" @click="showDialog('2')">绑定微信</el-dropdown-item>
                            <el-dropdown-item icon="User" @click="logOut">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
</el-dropdown> -->
            </template>
        </el-page-header>
        <el-dialog v-model="dialog" title="账号安全设置" width="500px">
            <el-tabs v-model="tab" @tab-change="changeTab">
                <el-tab-pane name="1" label="修改密码">
                    <div class="formBox">
                        <x-form class="form" :data="formConfig" :form-data="formData" @submit="submit"></x-form>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="2" label="绑定微信">
                    <div v-if="!userInfo.wx_bind_time" class="loginBox weichat" id="wxLogin">
                        <iframe :src="wxlink" height="500" frameborder="0"></iframe>
                    </div>
                    <div v-else class="isbind">
                        <div class="icon">
                            <i class="fab fa-weixin"></i>
                            <span>已成功绑定微信</span>
                        </div>
                        <div class="time">绑定时间：2025-12-1</div>
                        <div class="btn">
                            <el-button type="danger" @click="unBindWx">解除绑定</el-button>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        
    </div>
</template>

<script setup lang="ts">
import { ArrowRight, ArrowDown } from '@element-plus/icons-vue';
import { computed, nextTick, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useChangePwd, useLogOut, useSaveBindWx } from '@/hooks/user';
import xForm from '@/components/xForm/index.vue';
import { getWxqrcode, unbindwx } from '@/api/user';

// 用户信息
const userStore: any = useUserStore();
const userInfo = userStore.info;


const logOut = () => {
    ElMessageBox.confirm('您确定要退出登录吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    })
        .then(() => {
            useLogOut();
            router.replace({ path: '/login' });
        })
        .catch((action: string) => {
            console.log(action);
        });
};

// 面包屑导航
const route: any = useRoute();
const history = computed(() => {
    const list = route.matched.map((item: any) => {
        if (item.path == '/') {
            return false;
        }
        return item;
    });
    console.log(list);

    return list.filter(Boolean);
});

// 返回
const router = useRouter();
const backPage = () => {
    router.back();
};

// 修改密码
const dialog = ref(false);
const showDialog = (key: string) => {
    dialog.value = true;
    tab.value = key
    if (key == '2' && !userInfo.wx_bind_time && !isInitWx.value) {
        initWeLogin()
    }
};
const closeDialog = () => {
    dialog.value = false;
};
const tab = ref('1');

const changeTab = (t: any) => {
    if (t == '2' && !userInfo.wx_bind_time && !isInitWx.value) {
        nextTick(() => {
            initWeLogin();
        })
    }
};

const formData = ref({
    oldPsw: '',
    newPsw: '',
    confirmPsw: '',
});
const formConfig = ref({
    labelPosition: 'top',
    submitBtn: true,
    options: [
        {
            type: 'input',
            label: '当前密码',
            showPassword: true,
            prop: 'oldPsw',
            placeholder: '请输入当前密码',
        },
        {
            type: 'input',
            label: '新密码',
            showPassword: true,
            prop: 'newPsw',
            placeholder: '请输入新密码',
        },
        {
            type: 'input',
            label: '确认密码',
            showPassword: true,
            prop: 'confirmPsw',
            placeholder: '请再次输入新密码',
        },
    ],
    rules: {
        oldPsw: [
            { required: true, message: '请输入当前密码', trigger: 'blur' },
            { min: 8, max: 16, message: '密码长度为8到16位', trigger: 'blur' },
        ],
        newPsw: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 8, max: 16, message: '密码长度为8到16位', trigger: 'blur' },
        ],
        confirmPsw: [
            { required: true, message: '请再次输入新密码', trigger: 'blur' },
            {
                validator: (rule: any, value: string, callback: any) => {
                    if (!value) {
                        callback(new Error('请再次输入新密码'));
                    } else if (value !== formData.value.newPsw) {
                        callback(new Error('两次输入的密码不一致'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur',
            },
        ],
    },
});
const submit = (data: any) => {
    console.log(data);
    const params = {
        ...data.value,
    };
    useChangePwd(params).then((res: any) => {
        ElMessage.success(res.msg);
        router.replace({ path: '/login' });
    });
};
// 绑定微信

// 微信登录
const isInitWx = ref(false);
const wxlink = ref('')
const initWeLogin = () => {
    getWxqrcode({ path: encodeURIComponent('/company/login/success?isbind=1') }).then(res => {
        if (res.code == 0) {
            wxlink.value = res.data.link
        }

    })
};

// 解除绑定
const unBindWx = () => {
    ElMessageBox.confirm('您确定要解除绑定吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    })
        .then(() => {
            unbindwx().then((res) => {
                if (res.code == 0) {
                    useSaveBindWx()
                    ElMessage({
                        type: 'success',
                        message: '解绑成功',
                    });
                    dialog.value = false
                }
            });
        })
}
// 前往充值
const toVersion = () => {
    router.push({ name: 'version' });
};

</script>

<style lang="less" scoped>
.el-page-header,
.pageHeader {
    width: 100%;


    .loginBox {
        display: flex;
        justify-content: center;
    }

    .isbind {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        padding: 40px 20px;

        .icon {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
            color: #07c160;

            i {
                font-size: 45px;
            }
        }

        .time {
            color: #a8abb2;
        }
    }

    .user {
        display: flex;
        gap: 10px;
        align-items: center;
        padding: 10px;
        cursor: pointer;
        position: relative;

        &:hover .extraBox {
            visibility: visible;
            opacity: 1;
            transform: translate(0, 0);
        }

        .extraBox {
            position: absolute;
            min-width: 300px;
            padding: 10px;
            background: #fff;
            box-shadow: 0 0 8px rgba(0, 0, 0, .1);
            border-radius: 8px;
            top: 100%;
            right: 0;
            visibility: hidden;
            opacity: 0;
            transform: translate(0, 10px);
            transition: all .3s;
            z-index: 10;

            .footer {
                display: flex;
                justify-content: flex-end;
                gap: 10px;
                border-top: 1px solid #ebeef5;
                margin-top: 10px;
                padding-top: 10px;
            }

            .card {
                display: flex;
                flex-direction: column;

                gap: 10px;
                .title {
                    font-size: 14px;
                    font-weight: 600;
                    color: #606266;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                .content {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;

                    .uinfo {
                        display: flex;
                        gap: 10px;
                    }

                    .rows {
                        display: flex;
                        flex-direction: column;
                        color: #909399;
                        font-size: 12px;
                    }

                    .row {
                        display: flex;
                        align-items: center;
                        gap: 10px;

                    }

                    .info {
                        display: flex;
                        flex-direction: column;
                        // gap: 4px;
                        color: #909399;
                        font-size: 12px;

                        .name {
                            color: #303133;
                            font-size: 14px;
                        }


                    }
                }
            }
        }

        .info {
            &.col {
                gap: 0px;
            }

            .name {
                font-size: 15px;
            }

            .days {
                color: #409eff;
                max-width: 100px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .formBox {
        height: 320px;
        // padding: 10px;
        display: flex;
        align-items: center;

        .form {
            width: 100%;
        }
    }
}
</style>
